import { SlyShoppingPrizeDescription } from "./sly-shopping-prize-description";
import { SlyShoppingWave } from "./sly-shopping-wave";
import mixins from "@/mixins";

export class SlyShoppingPrizeModel {
  id?: number;
  waveId?: number;
  category?: "cashback" | "coupon";
  gcn?: number;
  dateFrom?: Date | undefined;
  couponId?: number;
  specialActionId?: number;
  description?: string;
  points?: number;
  article?: number;
  validity?: number;

  commonValidator?: boolean;

  constructor(prize?: SlyShoppingPrizeDescription) {
    this.id = prize?.prize_id;
    this.waveId = prize?.wave_id;
    this.category = prize?.item_cat;
    this.gcn = prize?.gcn;
    this.dateFrom = prize?.date_from;
    this.couponId = prize?.coupon_id;
    this.specialActionId = prize?.special_action_id;
    this.description = prize?.loy_desc;
    this.points = prize?.points;
    this.article = prize?.article;
    this.validity = prize?.validity;
  }
}

export class SlyShoppingWaveModel {
  waveId?: number;
  dateFrom?: Date;
  dateTo?: Date;
  prizes?: SlyShoppingPrizeModel[];

  constructor(wave?: SlyShoppingWave, prizes: SlyShoppingPrizeDescription[] = []) {
    this.waveId = wave?.wave_id;
    if (wave && wave.dateFrom && wave.dateTo) {
      const moscowTimezoneOffset = 3 * 60;

      const dateFrom = mixins.formDate(wave.dateFrom.toString()) ?? new Date();
      const dateTo = mixins.formDate(wave.dateTo.toString()) ?? new Date();

      this.dateFrom = new Date(
        mixins.addMinutes(dateFrom, -1 * moscowTimezoneOffset + dateFrom.getTimezoneOffset())
      );
      this.dateTo = new Date(
        mixins.addMinutes(dateTo, -1 * moscowTimezoneOffset + dateTo.getTimezoneOffset())
      );
      this.dateTo = new Date(this.dateTo.setHours(0, 0, 0, 0));
    }

    this.prizes = prizes.map((prize: SlyShoppingPrizeDescription) => new SlyShoppingPrizeModel(prize));
  }
}

export interface SlyShoppingNewWaveDataResponse {
  wave: SlyShoppingNewWave;
  prize_descriptors: SlyShoppingPrizeDescriptor[];
}
export interface SlyShoppingNewWave {
  wave_id: number;
  date_from: string;
  date_to: string;
}
export interface SlyShoppingPrizeDescriptor {
  prize_id: number;
  item_cat: "coupon" | "cashback";
  description: null;
}

export class SlyShoppingNewPrize {
  prize_id?: number;
  wave_id?: number;
  item_cat?: "coupon" | "cashback";
  gcn?: number;
  date_from?: string;
  coupon_id?: number;
  special_action_id?: number;
  loy_desc?: string;
  points?: number;
  article?: number;
  validity?: number;
}
